module.exports = __webpack_public_path__ + "img/pre-img.8097823a.png";